import { render, staticRenderFns } from "./image-field.vue?vue&type=template&id=4d8d169a&scoped=true&"
import script from "./image-field.vue?vue&type=script&lang=js&"
export * from "./image-field.vue?vue&type=script&lang=js&"
import style0 from "./image-field.vue?vue&type=style&index=0&id=4d8d169a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d169a",
  null
  
)

export default component.exports